import {assert} from 'assert-ts';
import type {PartValueModifier} from 'schemaDefinition/types';
import type {ThesaurusNode} from 'services/thesaurus/types';
import {isNullish} from 'schemaDefinition/functions';

export const grepLevelModifier: PartValueModifier = ({
  value,
  part,
  additionalData,
}) => {
  assert(
    part && part.key === 'grep',
    'grepLevelModifier: part must have key grep',
    part,
  );

  assert(
    isNullish(value) || Array.isArray(value),
    'grepLevelModifier: value must be null or an array',
    {value, part},
  );

  const addedNode = additionalData as ThesaurusNode | undefined;
  const values = [...((value ?? []) as Array<string>)];

  if (addedNode?.related) {
    addedNode.related.forEach(relatedNode => {
      if (
        relatedNode.type === 'year_level' &&
        !values.includes(relatedNode.code)
      ) {
        values.push(relatedNode.code);
      }
    });
  }

  if (values.length > 0) {
    return {value: values};
  }

  return {value};
};
